import isEmpty from "lodash/isEmpty";
import { ActivityProfile } from "PFTypes";

export const getActiveActivityProfiles = <TProfile extends ActivityProfile = ActivityProfile>(
  activityProfiles: TProfile[]
): TProfile[] => activityProfiles.filter(({ profile }) => !isEmpty(profile));
